import * as tslib_1 from "tslib";
import { Review } from '../../shared/models/review.model';
/**
 * Business review/rating model
 */
var BusinessReview = /** @class */ (function (_super) {
    tslib_1.__extends(BusinessReview, _super);
    function BusinessReview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Parses review
     * @param data {any} Review data as returned by API
     * @return {AirportReview} Parsed review
     */
    BusinessReview.parse = function (data) {
        var review = Review.parse(data);
        review.businessId = data.businessId;
        return review;
    };
    return BusinessReview;
}(Review));
export { BusinessReview };
